import { useEffect } from "react";

export const useTaskManagement = (
  setPop,
  popPosition,
  preferences,
  generateCategoryImages,
  activeSlate,
  fetchTasks,
  fetchTasksDeps,
  appLoaded
) => {
  // Pop animation effect
  useEffect(() => {
    if (popPosition.x && popPosition.y) {
      setPop(true);
      setTimeout(() => setPop(false), 2000);
    }
  }, [popPosition, setPop]);

  // Generate category images when preferences change
  useEffect(() => {
    if (preferences.length > 0) {
      generateCategoryImages();
    }
  }, [preferences, activeSlate, generateCategoryImages]);

  // Fetch tasks when app loads
  useEffect(() => {
    if (appLoaded) {
      fetchTasks();
    }
  }, [fetchTasks, appLoaded, ...fetchTasksDeps]);
};
